// Clears each successfully processed file from a pond a few seconds after its
// "Upload complete" bar shows. For ponds whose uploads are represented
// elsewhere in the UI (a table row, a list entry), the completed bar is
// transient feedback, not state — leaving it around reads as something still
// waiting on the user. Failed items stay visible so errors aren't missed.
//
// Only use this on ponds where the completed item has no ongoing job. Image
// ponds (the item is the preview) and attachment ponds (the item shows what's
// attached) must keep their items.
const COMPLETED_DISPLAY_MS = 4000

export function autoRemoveCompletedUploads(pond) {
  pond.on("processfile", function (error, file) {
    if (error) return
    setTimeout(function () {
      // revert: false — only the bar goes away, never the upload itself.
      pond.removeFile(file.id, { revert: false })
    }, COMPLETED_DISPLAY_MS)
  })
}
